// 设计文档: https://km.sankuai.com/collabpage/1755818928
const Raptor = Mach.requireModule('Raptor');

export const RAPTOR_SAMPLE_RATE = 1; // raptor采样率

const defaultTags = {
  container: 'Mach Pro',
  osName: Mach.env.osName ?? '',
  osVersion: Mach.env.osVersion ?? '',
  appVersion: Mach.env.version ?? '',
  platform: Mach.env.isAndroid ? 'Android' : 'iOS',
};

/**
 *  eventIndex: 事件节点顺序,影响raptor数据 ,修改时请确保节点顺序正确
 * label: 用于日志中文展示
 * key:用于raptor上报,禁止修改
 * */
const keyLabels = {
  FFS_EVENT_HOMEPAGE_APPEAR: { label: '事件:首页出现', eventIndex: 1 },
  FFS_EVENT_HOMEPAGE_POPUP: { label: '事件:首页加载', eventIndex: 1 },
  FFS_EVENT_ADDRESS_CLOSE: { label: '事件:关闭地址选择弹窗', eventIndex: 1 },

  FFS_EVENT_ADDRESS_SHOW: { label: '事件:打开地址弹窗', eventIndex: undefined },

  FFS_START_CHECK: { label: '校验开始', eventIndex: 2 },
  FFS_PASS_CHECK: { label: '校验通过', eventIndex: 3 },

  FFS_RECEIVE_DATA: { label: '收到接口数据', eventIndex: 4 },
  FFS_LOAD_ALERT: { label: 'boundle完成加载', eventIndex: 5 },
  FFS_SHOW_ALERT: { label: '最终展示', eventIndex: 6 },
  FFS_EVENT_TRAFFICHAVEN_FINISH: { label: '拉承一体操作完成', eventIndex: 999 }, // 拉成一体的数据结束之后, 天降才有可能会弹出来
};
 type ShowAlertEventNode = keyof typeof keyLabels

/**
 * 天降弹窗漏斗,定位事件最终停留位置
 * 节点延迟日志上报,同一个事件,只上报一次,新节点覆盖旧节点
 *
 * */
const eventTimeouts: {[eventId: string]: number;} = {};
const reportFinalNode = (eventId: string = '', eventIndex: number | undefined) => {
  if (!eventId || !eventIndex) return;
  if (eventTimeouts[eventId]) { clearTimeout(eventTimeouts[eventId]); } // 清除上一节点的上报
  eventTimeouts[eventId] = setTimeout(() => {
    Raptor?.reportMetrics({ FFS_FUNNEL: eventIndex }, defaultTags, RAPTOR_SAMPLE_RATE); // 天降弹窗漏斗
  }, 3000); // 延迟3秒上报,后端接口1s超时,过程中可能有接口请求与boundle加载,所以延迟时间尽可能长些
};

/** 记录Logan日志, 关键节点上报raptor*/
export const logEventNode = (keyName: ShowAlertEventNode, extra: {data: Object; withRaptor?: boolean; eventId?: string;}) => {
  try {
    const eventInfo = keyLabels[keyName];
    if (!eventInfo) return;
    const logName = `天降弹窗节点${eventInfo.eventIndex}-${eventInfo.label}`;
    extra.withRaptor && Raptor?.reportMetrics({ [keyName]: 1 }, defaultTags, RAPTOR_SAMPLE_RATE); // raptor关键节点上报
    reportFinalNode(extra.eventId, eventInfo.eventIndex); // 漏斗上报

    Mach.requireModule('Logan').log(JSON.stringify({ logName, eventId: extra.eventId, data: extra.data })); // Logan记录
  } catch (error) {
    console.log(error);
  }
};
